import React from 'react';
import SelectQuestion from 'pages/admin/interview_sheet/questions/SelectQuestion';

const SingleSelectQuestion = props => {
    return <SelectQuestion isMultiple={false} {...props} />;
};

export default SingleSelectQuestion;
